
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '征减免税方式名称',
value: this.$route.params.Item.PER_Name
}, {
label: '征减免税方式说明',
value: this.$route.params.Item.PER_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/ExemptionReliefWayDetail.vue